import { useTranslation } from 'react-i18next';
import { FormField } from '@noor/ui';

const LANGUAGES = [
  { suffix: 'Ru', lang: 'ru' },
  { suffix: 'Uz', lang: 'uz' },
  { suffix: 'En', lang: 'en' },
] as const;

export function CompositionNutritionFields({
  fieldClassName,
  messageClassName,
}: {
  fieldClassName?: string;
  messageClassName?: string;
}) {
  const { t } = useTranslation('eats');
  return (
    <>
      <div className="flex flex-col gap-5">
        <span className="text-lg font-semibold">
          {t('menu.product.form.compositionSection')}
        </span>
        <div className="flex flex-col gap-5 sm:flex-row">
          {LANGUAGES.map(({ suffix, lang }) => (
            <FormField key={suffix} name={`composition${suffix}`} className="flex-1">
              <FormField.Label>{t(`utilities.languages.${lang}`)}</FormField.Label>
              <FormField.TextArea
                className={fieldClassName}
                placeholder={t('menu.product.form.compositionSection')}
              />
              <FormField.Message className={messageClassName} />
            </FormField>
          ))}
        </div>
      </div>
      <div className="flex flex-col gap-5">
        <span className="text-lg font-semibold">
          {t('menu.product.form.nutritionSection')}
        </span>
        <div className="flex flex-col gap-5 sm:flex-row">
          {(['calories', 'fats', 'proteins'] as const).map((name) => (
            <FormField key={name} name={name} className="flex-1">
              <FormField.Label>{t(`menu.product.form.${name}`)}</FormField.Label>
              <FormField.Number
                className={fieldClassName}
                min={0}
                max={name === 'calories' ? 100_000 : 10_000}
                decimals={name === 'calories' ? 0 : 1}
                suffix={
                  name === 'calories'
                    ? t('menu.product.form.kcal')
                    : t('menu.product.form.grams')
                }
              />
              <FormField.Message className={messageClassName} />
            </FormField>
          ))}
        </div>
      </div>
    </>
  );
}
